import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
    providedIn: 'root'
})
export class ApiEndpoint {

 
    private baseEndpoint: string = `${environment.HOST}${URL_MAP.API.baseURL}`;
    private baseEndpointTerm: string = `${environment.HOST}${URL_MAP.API.termURL}`;
    private baseEndpointService: string = `${environment.HOST}${URL_MAP.API.baseURL}`; //originalmente se usa serviceURL, ver excel adjunto
    private baseEndpointQuoter: string = `${environment.serviceURLQuoter}`;
    private baseEndpointProduct: string = `${environment.HOST}${URL_MAP.API.serviceProduct}`;

    constructor() {
    }

    URL_FILE(): string { return `${this.baseEndpoint}/files` };
    URL_FILE_RECORD(): string { return `${this.baseEndpoint}/Archivo` };

    URL_TERM(): string { return `${this.baseEndpointTerm}` };
    // URL_TERM_RECORD(): string { return `${this.baseEndpointTerm}`};

    URL_NEWS(): string { return `${this.baseEndpoint}/Noticias` };
    URL_NEWS_BY_TYPES(idTPNU: number, idType: number): string { return `${this.URL_NEWS()}/types/${idTPNU}/${idType}/admin` };


    URL_NEWS_TYPE(): string { return `${this.baseEndpoint}/NoticiasTipo` };
    URL_NEWS_USER_TYPE(): string { return `${this.baseEndpoint}/NoticiasTipoUsuario` };

    URL_COMPANY(): string { return `${this.baseEndpoint}/Compania` };
    URL_COMPANY_TYPE(idProgram: number, idRegion: number): string { return `${this.URL_COMPANY()}/types/${idProgram}/${idRegion}` };

    URL_REGIONAL(): string { return `${this.baseEndpoint}/Regional` };
    URL_PROGRAM(): string { return `${this.baseEndpoint}/Programa` };

    URL_LOGIN(): string { return `${this.baseEndpoint}/profile/auth` } // jasrGamer 'this.urlLog' para pruebas <---> 'this.baseEndpoint' para produccion

    URL_PEOPLE_COOMEVA(): string { return `${this.baseEndpoint}/afe/` }

    URL_SERVICE(): string { return `${this.baseEndpointService}/afe/` }

    URL_SERVICE_QUOTER(): string { return `${this.baseEndpointQuoter}/` }

    URL_PRODUCT_COOMEVA(): string { return `${this.baseEndpointProduct}/carnet-by-program-group` }

    URL_SERVICE_QUOTER_MY_QUOTES_LIST(): string { return `${this.baseEndpointQuoter}/cotizador/page` };

    URL_SERVICE_QUOTER_MY_QUOTES(): string { return `${this.baseEndpointQuoter}/cotizador` };
}